// frontend/src/core/theme/ThemeToggle.tsx
import * as React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useTheme, type ThemeMode } from './ThemeProvider';

const NEXT: Record<ThemeMode, ThemeMode> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};
const LABELS: Record<ThemeMode, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'System',
};

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  const Icon = mode === 'light' ? Sun : mode === 'dark' ? Moon : Monitor;
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-8 w-full justify-start px-2 text-muted-foreground"
      aria-label={`Theme: ${LABELS[mode]}. Click to cycle.`}
      onClick={() => setMode(NEXT[mode])}
    >
      <Icon className="h-4 w-4 mr-2" />
      <span className="text-xs">{LABELS[mode]}</span>
    </Button>
  );
}
